const Container = (props: any) => (
  <div ref={props.innerRef} {...props.innerProps}>
    {props.children}
  </div>
);

export default Container;
